/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPagingResponseOfAllotmentEvolutionFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeAgGridClientQuery, serializePagingResponseOfAllotmentEvolution, type AgGridClientQuery, type PagingResponseOfAllotmentEvolution, type ValidationProblemDetails } from '../models/index.js';
// @ts-ignore
import { CreateCsvRequestBuilderRequestsMetadata, type CreateCsvRequestBuilder } from './createCsv/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /AllotmentEvolution
 */
export interface AllotmentEvolutionRequestBuilder extends BaseRequestBuilder<AllotmentEvolutionRequestBuilder> {
    /**
     * The CreateCsv property
     */
    get createCsv(): CreateCsvRequestBuilder;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagingResponseOfAllotmentEvolution>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PagingResponseOfAllotmentEvolution | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const AllotmentEvolutionRequestBuilderUriTemplate = "{+baseurl}/AllotmentEvolution";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AllotmentEvolutionRequestBuilderNavigationMetadata: Record<Exclude<keyof AllotmentEvolutionRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    createCsv: {
        requestsMetadata: CreateCsvRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const AllotmentEvolutionRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: AllotmentEvolutionRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagingResponseOfAllotmentEvolutionFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAgGridClientQuery,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
